<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div>
    <div class="footer card card-style mx-0 mb-0">
      <a href="#" data-menu="menu-page" class="footer-title pt-4 mb-3">
        <img src="@/assets/drtheiss.svg" style="width: 16rem; margin: 0 auto;" />
      </a>
      <p class="boxed-text-l">
        JEDNA SPOLOČNOSŤ - MNOŽSTVO ZNAČIEK
      </p>
      <p class="footer-copyright pb-3 mb-1">
        Copyright &copy; Vilten s.r.o. <span id="copyright-year">2021</span>. All Rights Reserved.
      </p>
    </div>
    <div class="footer-card card shape-rounded bg-20" style="height:230px">
      <div class="card-overlay bg-highlight opacity-90"></div>
    </div>
  </div>  
</template>

<script>
export default {
  name: 'FooterCard'
}
</script>
